/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { GetTableFooter } from '../../../_component/tableFooter';

export function AdminOfflineStore(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [items, setItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  const [inputStatus, setInputStatus] = useState<number>(0);
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getOfflineStoreList();
  }, [currentPage]);

  // 서점 선택하기
  const onClickRadioBtn = (radioBtnName: number) => {
    setInputStatus(radioBtnName);
  };

  // 선택한 서점 삭제
  const onClickDelete = async () => {
    if (inputStatus <= 0) {
      dispatch(toast.error({ message: '선택된 항목이 없습니다.' }));
    } else {
      await server
        .deleteOfflineStore(inputStatus)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: `서버로부터 응답이 없습니다.` }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: `파라미터 오류` }));
          } else {
            dispatch(toast.info({ message: '선택된 항목이 삭제되었습니다.' }));
            getOfflineStoreList();
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  const updateStore = (id: any) => {
    routeProps.history.push({
      pathname: `/admin/store/offline-mod/${id}`,
    });
  };

  // 오프라인 서점 목록 가져오기
  const getOfflineStoreList = async () => {
    await server
      .getOfflineStore(currentPage, 10)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload.items);
          setMeta(payload.meta);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 테이블 생성
  const createOfflineStoreList = () => {
    return (
      <div className="table">
        <ul className="row title">
          <li className="check"> </li>
          <li className="counter">수정하기</li>
          <li className="counter">서점명</li>
          <li className="counter">전화번호</li>
          <li className="counter">지역</li>
          <li className="flex-20">주소</li>
        </ul>
        {items?.map((item: any) => (
          <ul className="row" key={item.id}>
            <li className="check">
              <div className="check">
                <input
                  id={item.id}
                  type="radio"
                  checked={inputStatus === item.id}
                  onChange={() => onClickRadioBtn(item.id)}
                />
                <label htmlFor={item.id} />
              </div>
            </li>
            <li className="counter" onClick={() => updateStore(item.id)}>
              [수정]
            </li>
            <li className="counter">{item.name}</li>
            <li className="counter">{item.tel}</li>
            <li className="counter">{item.district}</li>
            <li className="flex-20">{item.address}</li>
          </ul>
        ))}
      </div>
    );
  };

  // AdminOfflineStore 리턴값
  return (
    <main className="list wrapper">
      <div className="title">
        <h1>오프라인 서점 관리</h1>
        <div className="buttons">
          <button
            type="button"
            onClick={() => {
              history.push('/admin/store/offline-add');
            }}
          >
            등록하기
          </button>
        </div>
      </div>
      <div className="content">
        {createOfflineStoreList()}
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '삭제',
          onClickDelete,
          true
        )}
      </div>
    </main>
  );
}
